<template>
     <div class="main">
       <div class="warp">
            <!-- header -->
            <div class="header">文章详情</div>
            <!-- 新闻部分 -->
            <div >
                <div class="content_title">
                {{articlemodelshare.articleTitle}}
                </div>
                <div class="content_title_label">
                    <div class="content_title_label_left">{{articlemodelshare.brieflyTitle}}</div>
                    <div class="content_title_label_right">{{articlemodelshare.addTime}}发布</div>
                </div>
                <!-- 文章内容部分 -->
                <div class="articleContent">
                    <div v-html="articlemodelshare.articleContent">
                    </div>
                </div>
            </div>
            <!-- 评论部分 -->
            <div class="comment">
                <!-- 所有的评论的头部 -->
                <div class="all_comments">所有评论({{articlemodelshare.commentNum}}条)</div>
                <!-- 所有的评论列表 -->
                <div class="all_comment_list" v-if="isdata==1">
                    <!-- 第一条评论 -->
                    <div class="all_comment_list_1"  v-for="(item,k) in articlemodelshare.commentList" :key="k">
                        <div>
                            <div class="user_img">
                                <img src="../../assets/img/default.png" alt="" v-if="item.headImg==''">
                                     <img :src="item.headImg" alt="" v-else>
                            </div>
                        </div>
                       <div style="width: 100%;">
                            <div class="user_info">
                                <div class="user_info_left">
                                    <div class="user_name_box">
                                        <p class="user_name">{{item.nickName}}</p>
                                    </div>
                                </div>
                                <div class="like_box">
                                    <span v-if="item.isPraise>0"><img src="../../assets/img/isprise.png" alt=""></span>
                                    <span v-else><img src="../../assets/img/prise.png" alt=""></span>
                                    <span class="prise_box_num">{{item.praiseNum}}</span>
                                </div>           
                            </div>
                            <div class="all_comment_list_1_text">
                                {{item.commentContent}}
                            </div>
                            <div class="all_comment_list_1_time">
                                <span class="all_comment_list_1_time_report">{{item.addTime}} · 举报</span>
                                <span class="all_comment_list_1_time_reply">回复</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 暂无数据 -->
                <div v-else class="nodata">
                        <div>
                            暂无数据
                        </div>
                </div>
            </div>
            <!-- 底部 -->
            <div class="bottom_wrap">
                <div class="bottom">
                    <div class="bottom_con">
                        <div class="bottom_left">
                            <div class="share_img">
                                <img src="../../assets/img/logo.png" alt="">
                            </div>
                            <div class="share_des">
                                <p>线上掌柜</p>
                                <p>新人注册有红包</p>
                            </div>
                            <div class="clear"></div>
                        </div>
                        <div class="bottom_right"  @click="goDownload">
                            <div>立刻加入</div>
                        </div>
                        <div class="clear"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Toast} from 'vant';
import { articlemodelshareModule } from "../../request/myFreecharge";
import { publicFun } from "@/tools/time.js"
export default {
    data(){
        return{
            articlemodelshare:{},
            isdata:2
        }
    },
    created:async function(){
        await this.freeshareorder()
    },
    methods:{
        async freeshareorder(){
            //  this.$route.query.articleID=10
            //  this.$route.query.usertoken=1630333978720
             await articlemodelshareModule.articlemodelshare(this.$route.query.articleID,this.$route.query.usertoken).then((response) => {
               switch(response.data.code){
                    case 100:
                         {
                         
                            this.articlemodelshare=response.data.result
                            this.articlemodelshare.addTime=publicFun.timestampToTime(Number(response.data.result.addTime))
                            console.log(response.data.result )     
                            if(this.articlemodelshare.commentList.length>0){
                                this.isdata=1
                                    this.articlemodelshare.commentList.forEach(e=>{
                                    e.addTime=publicFun.dateDiff(Number(e.addTime))
                                })
                            }  
                         }
                        break;
                    case 101:
                        break;
                    case 102:
                        Toast.clear();
                        break;
                    case 100001:
                        // Toast.clear();
                        // Toast({
                        //     message: '网络连接异常',
                        //     position: 'center',
                        // });
                        break;
                }
            }).catch(()=>{})
        },
        goDownload(){
            this.$router.push({
                path:'/download',
                query:{
                    marktype:1,
                }
            })
            
        },
    }
}
</script>
<style scoped>
.warp{
    width: 87.2%;
    margin: 0 auto;
}
.header{
    font-size: 0.5rem;
    font-weight: bold;
    color: #323232;
    margin-left: 1.03rem;
    padding-top: 0.533rem;
}
.content_title{
    font-size: 0.506rem;
    font-weight: Bold;
    color: #323232;
    text-align: left;
    width: 8.6rem;
    padding: 0.8rem 0rem 0.533rem 0rem;
}
.content_title_label{
    display: flex;
    align-items: center;
}
.content_title_label div{
    font-size: 0.32rem;
    font-weight: Regular;
    color: #909090;
}
.content_title_label_right{
    margin-left: 0.533rem;
}
.articleContent{
     width: 100%;
    margin-top: 0.666rem;
}
.articleContent>div{
     width: 100%;
}
.articleContent>div>p{
     width: 100%;
}
.articleContent >>> img{
    width: 100%;
    object-fit: cover;
}

/* 评论 */
.user_info{
    width: 100%;
}
.user_img,.user_level_two_img,.user_name_box{
    float: left;
}
.user_img img{
    border-radius: 50%;
    width: 0.69rem;
    height: 0.69rem;
    object-fit: cover;
    vertical-align: middle;
}
.user_name_box{
    display: flex;
    margin-left: 0.26rem;
    align-items: center;
}
.user_name{
    color: #323232;
    font-size: 0.346rem;
    width: 5rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.like_box{
    float: right;
    font-size: 0.32rem;
    color: #909090;
    display: flex;
    align-items: center;
}
.activity_time{
    display: flex;
    flex-direction: column;
    margin-top:0.533rem;
    font-size: 0.373rem;
    color: #FF0000;
    font-weight: Medium;
    width: 7.6rem;
 
}

.all_comments{
    font-size: 0.426rem;
    font-weight: Bold;
    color: #323232;
    margin-top: 1.06rem;
}
.all_comment_list{
    margin-top: 0.4rem;
}
.all_comment_list_1 .user_info{
    display: flex;
    justify-content: space-between;
    align-content: center;
}
 .all_comment_list_1 .user_info_left{
    display: flex;
    align-content: center;
}
.all_comment_list_1{
    display: flex;
    padding: 0.433rem 0rem;
}
.all_comment_list  .all_comment_list_1  .user_info  .user_name_box  .user_name{
    font-size: 0.37rem;
    color: #8A0000;
    font-weight: Medium;
}
.all_comment_list  .all_comment_list_1  .user_info  .like_box  .prise_box_num{
    font-size:0.37rem;
    color:#323232;
    margin-left: 0.266rem;
}
.all_comment_list_1_text{
    font-size: 0.4rem;
    color: #323232;
    font-weight: Medium;
    padding: 0.497rem 0.64rem 0rem 0.26rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp:2;
    -webkit-box-orient: vertical;
    -webkit-box-orient: vertical;
}
.all_comment_list_1_time{
    margin-top: 0.42rem;
    display: flex;
    justify-content: space-between;
}
.all_comment_list_1_time_report{
    font-size: 0.32rem;
    color: #323232;
    font-weight: Medium;
    margin-left: 0.26rem;
}
.all_comment_list_1_time_reply{
    font-size: 0.32rem;
    color: #323232;
    font-weight: Medium;
}
.like_box img{
    width: 0.426rem;
    object-fit: cover;
}
.nodata{
    height: 3rem;
    display: flex;
    align-items: center;
    justify-content: space-around;
}
</style>